import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Stack, Section } from "@origin-digital/ods-core";
import { navigation } from "@origin-digital/reporting-client";
import { actionBarUpdate } from "@origin-digital/event-dispatcher";
import { SearchBanner } from "../components/SearchBanner/SearchBanner";
import { ChatController } from "../components/Chat";
import {
  SecondaryPlacementController,
  PrimaryPlacementController,
} from "../components/Pesonalisation";
import { IMetaData } from "../../../shared/interface/article";
import { Head } from "../components/Head";
import { ExperienceProvider } from "@origin-digital/features";
import { TrendingController } from "../components/Trending";
import { NumberOfItems } from "../components/Trending/Trending";

interface IScreenTemplateProps {
  title: string;
  description?: string;
  "data-id"?: string;
  children: React.ReactNode;
  isNative: boolean;
  isArticle?: boolean;
  isHome?: boolean;
  metaData?: IMetaData;
  labelId?: string;
}

export const ScreenTemplate = ({
  title,
  description,
  "data-id": dataId,
  children,
  isNative,
  isArticle = false,
  isHome = false,
  metaData,
  labelId,
}: IScreenTemplateProps) => {
  const { category, subCategory, articleId } = useParams();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [category, subCategory, articleId]);

  useEffect(() => {
    navigation("screen", {
      currentUri: window.location.host + window.location.pathname,
      friendlyUri: window.location.pathname
        .replace(/\/$/, "")
        .replace(/^\//, "")
        .replace(/\//g, ":"),
    });

    actionBarUpdate({
      mobileNavButton: isHome ? "none" : "back",
      component: isHome ? "h1" : "h3",
    });
  }, []);

  return (
    <Stack space="none">
      <Head metaData={metaData} />
      <Stack space="xsmall" data-id={dataId}>
        {/* Empty <div /> here adds padding between stacked elements */}
        <div />
        <Section backgroundColor="grey50">
          <SearchBanner
            title={title}
            description={description}
            isNative={isNative}
            hideTitleAndDescription={isArticle === true}
            hideBreadcrumbs={isHome === true}
            titleIsHeading={!isHome}
          />
          <PrimaryPlacementController />
        </Section>
        <Section backgroundColor="white">{children}</Section>
        <SecondaryPlacementController />
        <TrendingController
          labelId={labelId}
          numOfItems={NumberOfItems.Triple}
        />
        <Section backgroundColor="white">
          <ExperienceProvider mboxes={["OE-656-mbox"]}>
            <ChatController />
          </ExperienceProvider>
        </Section>
        {/* Empty <div /> here adds padding between stacked elements */}
        <div />
      </Stack>
    </Stack>
  );
};
